export const ACTIONS = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  SSO_SUCCESS: "SSO_SUCCESS",
  SET_URI_IDENTIFIER: "SET_URI_IDENTIFIER",
  SET_ROLE_BY_PATH: "SET_ROLE_BY_PATH",
  USER_SESSION_CREATED: "USER_SESSION_CREATED",
  SET_SOCKET: "SET_SOCKET",
  CREATE_SESSION_SUCCESS: "CREATE_SESSION_SUCCESS",
  USER_JOIN: "USER_JOIN",
  JOIN_SESSION: "JOIN_SESSION",
  PARTICIPANT_ADMITTED_OR_REJECTED: "PARTICIPANT_ADMITTED_OR_REJECTED",
  USER_ADMITTED: "USER_ADMITTED",
  SET_JOINING_USER_DETAILS: "SET_JOINING_USER_DETAILS",
  START_SESSION_SUCCESS: "START_SESSION_SUCCESS",
  SAVE_SESSION_TITLE: "SAVE_SESSION_TITLE",
  SAVE_CURRENT_SESSION_INVITEES: "SAVE_CURRENT_SESSION_INVITEES",
  VIEW_INVITEES: "VIEW_INVITIES",
  SET_PARTICIPANT_ID: "SET PARTICIPANT ID",
  SET_USER_NAME: "SET_USER_NAME",
  SET_SESSION_STATUS: "SET_SESSION_STATUS",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  SET_ADMIN_LOGO_URL: "SET_ADMIN_LOGO_URL",
  SET_ALLOWED_DOWNLOAD: "SET_ALLOWED_DOWNLOAD",
  RESET_SHOW_KMS_CONNECTION_STATUS: "RESET_SHOW_KMS_CONNECTION_STATUS",
  SET_LOCAL_STREAM: "SET_LOCAL_STREAM",
  SET_USER_PROFILE_DATA: "SET_USER_PROFILE_DATA",
  SET_SESSIONS_CAPACITY: "SET_SESSIONS_CAPACITY",
  GET_CUSTOMER_SMS_SEND_NUM: "GET_CUSTOMER_SMS_SEND_NUM",
  GET_CUSTOMER_SESSION_NUM: "GET_CUSTOMER_SESSION_NUM",
  DOWNLOAD_CUSTOMER_SESSION_NUM_CSV: "DOWNLOAD_CUSTOMER_SESSION_NUM_CSV",
  GET_CUSTOMER_ENCODING_TIME: "GET_CUSTOMER_ENCODING_TIME",
  GET_RECORDING_DATA_PRESIGNED: "GET_RECORDING_DATA_PRESIGNED",
  SET_IS_RECORDING: "SET_IS_RECORDING",
  SENDER_ID: "SENDER_ID",
  SET_IS_SCREEN_MASKING: "SET_IS_SCREEN_MASKING",
  SET_RUN_SCREEN_SHARE: "SET_RUN_SCREEN_SHARE",
  SET_PREVIEW_MODAL: "SET_PREVIEW_MODAL",
  SET_VIDEO_TRANSFORM: "SET_VIDEO_TRANSFORM",
  SET_PREVIEW_AUDIO: "SET_PREVIEW_AUDIO",
  SET_MEDIA_DEVICE: "SET_MEDIA_DEVICE",
  SET_VIDEO_DEVICE: "SET_VIDEO_DEVICE",
  SET_FACING_MODE: "SET_FACING_MODE",
  SET_VIRTUAL_BACKGROUND: "SET_VIRTUAL_BACKGROUND",
  SET_AUDIO_SETTING_MODAL: "SET_AUDIO_SETTING_MODAL",
  SET_IS_PRESENTER: "SET_IS_PRESENTER",
  SET_IS_FULLSCREEN_V2: "SET_IS_FULLSCREEN_V2",
  SET_IS_CALLING: "SET_IS_CALLING",

  WHITEBOARD: {
    // SET_PDF_WEBVIEWER_INSTANCE: "SET_PDF_WEBVIEWER_INSTANCE",
    SET_CANVAS_COLOR: "SET_CANVAS_COLOR",
    SET_ACTIVE_CANVAS: "SET ACTIVE CANVAS",
    UPLOAD_IMAGE_FLAG: "UPLOAD_IMAGE_FLAG",
    RESET_FRAME_LOCK_PARTICIPANT: "RESET_FRAME_LOCK_PARTICIPANT",
    ADD_CANVAS: "ADD_CANVAS",
    DELETE_CANVAS: "DELETE_CANVAS",
    UPDATE_CANVAS: "UPDATE_CANVAS",
    ADD_OBJECT: "ADD_OBJECT",
    DELETE_OBJECT: "DELETE_OBJECT",
    UPDATE_OBJECT: "UPDATE_OBJECT",
    MODIFY_OBJECT: "MODIFY_OBJECT",
    CLEAR_CANVAS: "CLEAR_CANVAS",
    SET_CLEAR_CANVAS_FLAG: "SET_CLEAR_CANVAS_FLAG",
    STORE_CANVASES: "STORE_CANVASES",
    SET_CANVAS_DATA: "SET_CANVAS_DATA",
    SET_CANVAS_THUMBNAIL: "SET_CANVAS_THUMBNAIL",
    SET_DEFAULT_FONT_INFO: "SET_DEFAULT_FONT_INFO",
    SAVE_PDF_FILE: "SAVE_PDF_FILE",
    SET_WHITE_BOARD_REF: "SET_WHITE_BOARD_REF",
    CLEAR_PDF_PAGE_OBJECTS: "CLEAR_PDF_PAGE_OBJECTS",
    SET_SELECTED_ANNOTATION: "SET_SELECTED_ANNOTATION",
  },
  SNAPSHOT: {
    SET_SNAPSHOT_STATUS: "SET_SNAPSHOT_STATUS",
    SHOW_SNAPSHOT: "SHOW_SNAPSHOT",
    SET_SNAPSHOT_CAMERA_PERMISSION: "SET_SNAPSHOT_CAMERA_PERMISSION",
    ADD_CANVAS: "ADD_SNAPSHOT_CANVAS",
    DELETE_CANVAS: "DELETE_SNAPSHOT_CANVAS",
    ADD_OBJECT: "ADD_SNAPSHOT_CANVAS_OBJECT",
    CLEAR_CANVAS: "CLEAR_SNAPSHOT_CANVAS",
  },
  CHAT: {
    SET_MESSAGES: "SET_MESSAGES",
    ADD_MESSAGE: "ADD_MESSAGE",
    DISPLAY_MESSAGE: "DISPLAY_MESSAGE",
    MESSAGE_ARRIVED: "MESSAGE_ARRIVED",
    SET_MESSAGES_READ: "SET_MESSAGES_READ",
  },
  SET_LANGUAGE: "SET_LANGUAGE",
  LEAVE_SESSION_LOCAL: "LEAVE_SESSION_LOCAL",
  GET_ALL_SESSION_DATA: "GET_ALL_SESSION_DATA",
  SET_PARTICIPANTS: "SET_PARTICIPANTS",
  SET_ROOM_META_DATA: "SET_ROOM_META_DATA",
  SAVE_SCREENSHARING_PARTICIPANT_ID: "SAVE_SCREENSHARING_PARTICIPANT_ID",
  UPDATE_CURRENT_PARTICIPANT_INFO: "UPDATE_CURRENT_PARTICIPANT_INFO",
  SET_WEBRTC_REQUEST_PERMISSION: "SET_WEBRTC_REQUEST_PERMISSION",
  SAVE_MEDIA_SHARING_STATUS: "SAVE_MEDIA_SHARING_STATUS",
  SET_WEBRTC_REPLY_PERMISSION: "SET_WEBRTC_REPLY_PERMISSION",
  SET_WEBRTC_REPLY_PERMISSION_STATUS: "SET_WEBRTC_REPLY_PERMISSION_STATUS",
  SAVE_MESSAGES: "SAVE_MESSAGES",
  SET_HEADER_ICONS: "SET_HEADER_ICONS",
  UPDATE_HEADER_ICON_CLASSNAME: "UPDATE_HEADER_ICON_CLASSNAME",
  UPDATE_PARTICIPANTS: "UPDATE_PARTICIPANTS",
  SET_USER_EVICTED_FLAG: "SET_USER_EVICTED_FLAG",
  DELETE_PARTICIPANT: "DELETE_PARTICIPANT",
  SET_EVICTED_PARTICIPANT_DETAILS: "SET_EVICTED_PARTICIPANT_DETAILS",
  SET_END_SESSION_FLAG: "SET_END_SESSION_FLAG",
  UPADTE_PARTICIPANT_MEDIA_TYPE: "UPADTE_PARTICIPANT_MEDIA_TYPE",
  SET_AUDIO_OR_VIDEO_RTC_PEER: "SET_AUDIO_OR_VIDEO_RTC_PEER",
  ADD_SNAPSHOT: "ADD_SNAPSHOT",
  SET_SHOW_SNAPSHOT_POPUP: "SET_SHOW_SNAPSHOT_POPUP",
  SET_SNAPSHOTEE_ID: "SET_SNAPSHOTEE_ID",
  SET_SNAPSHOTER_ID: "SET_SNAPSHOTER_ID",
  SET_SNAPSHOT_PERMISSION_REPLY: "SET_SNAPSHOT_PERMISSION_REPLY",
  SET_SNASHOT_PERMISSION_STATUS: "SET_SNASHOT_PERMISSION_STATUS",
  UPADTE_PARTICIPANT_MEDIA_STATUS: "UPADTE_PARTICIPANT_MEDIA_STATUS",
  SET_ALLOW_EDIT: "SET_ALLOW_EDIT",
  RESET_ALL_PARTICIPANT_MEDIA_STATUS: "RESET_ALL_PARTICIPANT_MEDIA_STATUS",
  SET_SESSION_JOINED_FLAG: "SET_SESSION_JOINED_FLAG",
  RESET_SNAPSHOT_DATA: "RESET_SNAPSHOT_DATA",
  SET_SNAPSHOT_TAKEN: "SET_SNAPSHOT_TAKEN",
  SET_SWITCH_CAMERA: "SET_SWITCH_CAMERA",
  PDF: {
    FREEZE_FRAME: "FREEZE_FRAME",
    _FREEZE_FRAME: "_FREEZE_FRAME",
    CHANGE_ACTIVE_PAGE: "CHANGE_ACTIVE_PAGE",
    _CHANGE_ACTIVE_PAGE: "_CHANGE_ACTIVE_PAGE",
    SET_PAGE_POSITION: "SET_PAGE_POSITION",
    _SET_PAGE_POSITION: "_SET_PAGE_POSITION",
    _UPDATE_URL: "_UPDATE_URL",
    UPDATE_URL: "UPDATE_URL",
    SET_FULL_SCREEN: "SET_FULL_SCREEN",
    _SET_FULL_SCREEN: "_SET_FULL_SCREEN",
    SET_FIT_SCREEN: "SET_FIT_SCREEN",
    _SET_FIT_SCREEN: "_SET_FIT_SCREEN",
  },
  MAKE_PRESENTER: "MAKE_PRESENTER",
  NOTIFICATION: {
    ADD_ANNOTATION: "ADD_ANNOTATION",
    _ADD_ANNOTATION: "_ADD_ANNOTATION",
    REMOVE_ANNOTATION: "REMOVE_ANNOTATION",
    _REMOVE_ANNOTATION: "_REMOVE_ANNOTATION",
  },
  LOCATION: {
    START_LOCATION_SHARE: "START_LOCATION_SHARE",
    SET_LOCATION_PERMISSION_REPLY: "SET_LOCATION_PERMISSION_REPLY",
    CLEAR_LOCATION: "CLEAR_LOCATION",
    ADD_LOCATION_PARTICIPANT_ID: "ADD_LOCATION_PARTICIPANT_ID",
    SET_LOCATION_REPLY_PERMISSION_STATUS: "SET_LOCATION_REPLY_PERMISSION_STATUS",
    ADD_LOCATION_DATA: "ADD_LOCATION_DATA",
    STOP_LOCATION_SHARE: "STOP_LOCATION_SHARE",
    SHARE_ETA: "SHARE_ETA",
    GET_ALL_LOCATION_DATA: "GET_ALL_LOCATION_DATA",
    STOP_ETA_SHARE: "STOP_ETA_SHARE",
    LOCATION_SHARING_WINDOW_CLOSED: "LOCATION_SHARING_WINDOW_CLOSED",
  },
  APP_EMULATION: {
    APP_EMULATION_REQUEST: "APP_EMULATION_REQUEST",
    APP_EMULATION_REPLY: "APP_EMULATION_REPLY",
    _APP_EMULATION_REPLY: "_APP_EMULATION_REPLY",
    SET_IFRAME_URL: "SET_IFRAME_URL",
    SET_PARTICIPANT: "SET_PARTICIPANT",
    APP_EMULATION_END_SESSION: "APP_EMULATION_END_SESSION",
    APP_EMULATION_LEAVE_SESSION: "APP_EMULATION_LEAVE_SESSION",
    APP_EMULATION_JOIN_SESSION: "APP_EMULATION_JOIN_SESSION",
    PERMISSION_DENIDED: "PERMISSION_DENIDED",
    SET_APP_EMULATION_SESSION_STATUS: "SET_APP_EMULATION_SESSION_STATUS",
  },
  ERROR: {
    KMS_NOT_CONNECTED: "KMS_NOT_CONNECTED",
    KMS_CONNECTED: "KMS_CONNECTED",
    ERROR_IN_WEBRTC_MEDIA_SHARING: "ERROR_IN_WEBRTC_MEDIA_SHARING",
  },
  CALL_STATUS: "CALL_STATUS",
  SET_LOGO_URL: "SET_LOGO_URL",
  SET_TOKEN: "SET_TOKEN",
  SET_USER_ROLE: "SET_USER_ROLE",
  SET_CUSTOMER_ID: "SET_CUSTOMER_ID",
  CALL_MODAL_PERMISSION: "CALL_MODAL_PERMISSION",
  SET_QR_ERROR: "SET_QR_ERROR",
  SET_WEBRTC_SESSION_MEDIA: "SET_WEBRTC_SESSION_MEDIA",
  SET_QR_ACTIVE_SCREEN: "SET_QR_ACTIVE_SCREEN",
  SET_QR_LICENSE_KEY: "SET_QR_LICENSE_KEY",
  SET_MODULES: "SET_MODULES",
  STOP_VIDEO_CALL: "STOP_VIDEO_CALL",
  START_VIDEO_CALL: "START_VIDEO_CALL",
  SET_CAMERA_BUSY_FLAG: "SET_CAMERA_BUSY_FLAG",
  SET_TURN_SERVER_DATA: "SET_TURN_SERVER_DATA",
  SET_CUSTOMER_DATA: "SET_CUSTOMER_DATA",
  REMOVE_TOKEN_SESSION_KEY: "REMOVE_TOKEN_SESSION_KEY",
  SET_QR_SESSION_STATUS: "SET_QR_SESSION_STATUS",
  SET_SESSIONS_COUNT: "SET_SESSIONS_COUNT",
  CREATE_SNAPSHOT_RTC_PEER: "CREATE_SNAPSHOT_RTC_PEER",
  START_SNAPSHOT: "START_SNAPSHOT",
  SET_CALL_MEDIA_TYPE: "SET_CALL_MEDIA_TYPE",
  SET_USERS_COUNT: "SET_USERS_COUNT",
  ADMIN_ACTION: {
    SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
    SAVE_SESSION_KEY: "SAVE_SESSION_KEY",
    SAVE_SESSION_LIST_PAGE_SIZE: "SAVE_SESSION_LIST_PAGE_SIZE",
    SAVE_SESSION_LIST_CURRENT_PAGE_NO: "SAVE_SESSION_LIST_CURRENT_PAGE_NO",
    SAVE_USER_LIST_PAGE_SIZE: "SAVE_USER_LIST_PAGE_SIZE",
    SAVE_USER_LIST_CURRENT_PAGE_NO: "SAVE_USER_LIST_CURRENT_PAGE_NO",
    SMS_SENT_NUMBER_PAGE_NO: "SMS_SENT_NUMBER_PAGE_NO",
  },
  ORGANISATION_ACTION: {
    SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
    SET_ORGANIZATION_DATA: "SET_ORGANIZATION_DATA",
  },
  TEST_PAGE: {
    CAMERA_SELECTED: "CAMERA_SELECTED",
    MIC_SELECTED: "MIC_SELECTED",
  },
  SET_USING_CLUSTER_STATUS: "SET_USING_CLUSTER_STATUS",
  SET_COMPONENT_IN_FOCUS: "SET_COMPONENT_IN_FOCUS",
  SET_FULL_SCREEN: "SET_FULL_SCREEN",
  SET_SAVE_SESSION_DATA_FLAG: "SET_SAVE_SESSION_DATA_FLAG",
  SCHEDULE_SESSION_SUCCESS: "SCHEDULE_SESSION_SUCCESS",
  DELETE_SESSION_SUCCESS: "DELETE_SESSION_SUCCESS",
  SET_SESSION_SCHEDULE_LIST: "SET_SESSION_SCHEDULE_LIST",
  SET_SORTED_PARTICIPANT: "SET_SORTED_PARTICIPANT",
  SET_SESSION_TYPE: "SET_SESSION_TYPE",
  SET_EDIT_SESSION_DATA: "SET_EDIT_SESSION_DATA",
  SET_PASSCODE: "SET_PASSCODE",
  SET_PASSCODE_STATUS: "SET_PASSCODE_STATUS",
  PASSWORD_CHANGED: "PASSWORD_CHANGED",
  SET_TRAIL_HISTORY_DATA: "SET_TRAIL_HISTORY_DATA",
  SET_WAITING_USERS_DATA: "SET_WAITING_USERS_DATA",
  CO_BROWSE: {
    CO_BROWSE_REQUEST: "CO_BROWSE_REQUEST",
    CO_BROWSE_REPLY: "CO_BROWSE_REPLY",
    _CO_BROWSE_REPLY: "_CO_BROWSE_REPLY",
    SET_IFRAME_URL: "SET_IFRAME_URL",
    SET_PARTICIPANT: "SET_PARTICIPANT",
    CO_BROWSE_LEAVE_SESSION: "CO_BROWSE_LEAVE_SESSION",
    CO_BROWSE_JOIN_SESSION: "CO_BROWSE_JOIN_SESSION",
    CO_BROWSE_PERMISSION_DENIDED: "CO_BROWSE_PERMISSION_DENIDED",
    SET_CO_BROWSE_SESSION_STATUS: "SET_CO_BROWSE_SESSION_STATUS",
    CO_BROWSE_TOGGLE: "CO_BROWSE_TOGGLE",
    SET_TARGET_URL: "SET_TARGET_URL",
    CO_BROWSE_PARTICIPANT_STATUS_UPDATE: "CO_BROWSE_PARTICIPANT_STATUS_UPDATE",
    RESET_CO_BROWSE_SESSION_DETAILS: "RESET_CO_BROWSE_SESSION_DETAILS",
    SET_CO_BROWSE_DETAILS: "SET_CO_BROWSE_DETAILS"
  },
  CUSTOMER_CO_BROWSE: {
    SET_CUSTOMER_CO_BROWSE_REQUEST: "SET_CO_BROWSE_REQUEST",
    SET_CUSTOMER_CO_BROWSE_REPLY: "SET_CO_BROWSE_REPLY",
    CUSTOMER_CO_BROWSE_JOIN_SESSION: "CUSTOMER_CO_BROWSE_JOIN_SESSION,",
    CUSTOMER_CO_BROWSE_LEAVE_SESSION: "CUSTOMER_CO_BROWSE_LEAVE_SESSION",
    SET_CUSTOMER_CO_BROWSE_DATA: "SET_CUSTOMER_CO_BROWSE_DATA",
    SET_CUSTOMER_CO_BROWSE_STARTED: "SET_CUSTOMER_CO_BROWSE_STARTED",
    CUSTOMER_CO_BROWSE_PERMISSION_DENIDED: "CUSTOMER_CO_BROWSE_PERMISSION_DENIDED",
    CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE: "CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE",
    CUSTOMER_CO_BROWSE_END_SESSION: "CUSTOMER_CO_BROWSE_END_SESSION",
    SHOW_CUSTOMER_CO_BROWSE: "SHOW_CUSTOMER_CO_BROWSE",
    SHOW_TARGET_SITE_SELECTION_MODAL: "SHOW_TARGET_SITE_SELECTION_MODAL",
    /**
     * exCloserサーバー側から返ってきた appEmulationUrl の値を設定
     * @since 2022-11-29
     */
    SET_APP_EMULATION_URL: 'SET_APP_EMULATION_URL',
    /**
     * exCloserサーバー側から返ってきた appEmulationUrl の値を設定(フォロワー用)
     * @since 2022-12-07 
     */
    SET_APP_EMULATION_URL_FOR_FOLLOWER: 'SET_APP_EMULATION_URL_FOR_FOLLOWER',
    /**
     * layoutCode を設定
     * @since 2022-12-01
     */
    SET_LAYOUT_CODE: 'SET_LAYOUT_CODE',
  },
  SET_CONFIG: "SET_CONFIG",
  USER_PLUGIN_NOT_INSTALLED: "USER_PLUGIN_NOT_INSTALLED",
  RESET_PARTICIPANT_PLUGIN_INFO: "RESET_PARTICIPANT_PLUGIN_INFO",
  SET_IS_DISABLED_MENU: "SET_IS_DISABLED_MENU",
  SUPPORT_CENTER: {
    SET_SKILL_LIST: "SET_SKILL_LIST",
    SET_OPERATOR_STATUS: "SET_OPERATOR_STATUS",
    SET_SESSION_DETAILS: "SET_SESSION_DETAILS",
    SET_NUMBER_OF_CALLS_WAITING: "SET_NUMBER_OF_CALLS_WAITING",
    SET_CALL_TRANSFER_INFO: "SET_CALL_TRANSFER_INFO",
    SET_IS_TRANSFER_ERROR: "SET_IS_TRANSFER_ERROR",
    SET_IS_WEB_WORKER_ERROR: "SET_IS_WEB_WORKER_ERROR",
  },
  SET_CONTRACT_INFO: "SET_CONTRACT_INFO",
  SET_IS_CONTRACT_INFO_MODAL_OPENED: "SET_IS_CONTRACT_INFO_MODAL_OPENED",
  SET_IS_DISCONNECTED_WHILE_CALLING: "SET_IS_DISCONNECTED_WHILE_CALLING",
};

export const ANNOTATIONS = {
  LINE: "Line",
  CIRCLE: "Circle",
  RECTANGLE: "Rectangle",
  ERASE_OBJECT: "Erase Object",
  TEXT: "Text",
  SELECTION: "Selection",
  IMAGE_UPLOAD: "image_upload",
  IMAGE: "image",
  PDF_UPLOAD: "pdf_upload",
  UPLOAD_PDF_FROM_CLOUD: "upload_pdf_from_cloud",
  SPOTLIGHT: {
    NAME: "Spotlight",
    WIDTH: 40,
    COLOR: "rgba(255, 0, 0, 0.3)",
  },
  ERASER: {
    NAME: "Eraser",
    WIDTH: 35,
    COLOR: "white",
  },
  FREE_HAND: {
    NAME: "Free hand",
    WIDTH: 4,
    COLOR: "black",
  },
  PDF_HIGHLIGHT: {
    NAME: "Pdf Highlight",
    WIDTH: 25,
    COLOR: "rgba(255, 204, 0, 0.4)",
  },
};

export const CONFIG = {
  path: {
    login: "/",
    logout: "/logout",
    adminLogin: "/admin/login",
    superAdminLogin: "/superadmin/login",
    ssoLogin: "/sso/login/callback",
    ssoLogout: "/sso/logout/callback",
    ssoAuthenticated: "/sso/authenticated",
    createSession: "/createMeeting",
    dashboard: "/dashboard",
    userJoin: "/join",
    userEvicted: "/userEvicted",
    reJoin: "/rejoin",
    admin: "/admin",
    superAdmin: "/superadmin",
    forgotPassword: "/forgotPassword",
    setPassword: "/setPassword",
    sessionEnded: "/sessionEnded",
    startSession: "/startSession",
    qrExpired: "/qrExpired",
    pageNotFound: "/pageNotFound",
    waitingRoom: "/waitingRoom",
    startMeeting: "/startMeeting",
    scheduleMeeting: "/scheduleMeeting",
    trailHistory: "/trailHistory",
    waitingUsers: "/waitingUsers",
    joinWithPasscode: "/joinWithPasscode",
    addOrganization: "/superadmin/addOrganization",
    editOrganization: "/superadmin/editOrganization",
    supportCenter: "/admin/supportCenter",
    adminSettings: "/admin/settings",
    sessionEndScreen: "/sessionEndScreen",
    startSupportCenterSession: "/startSupportCenterSession",
    callWaiting: "/callWaiting",
    supportCenterReport: "/admin/supportCenterReport",
    serverUnreachable: "/serverUnreachable",
  },
};

export const URI_IDENTIFIER_MODIFICATION_NOT_ALLOWED_PATH = [
  CONFIG.path.userJoin, CONFIG.path.joinWithPasscode, CONFIG.path.ssoLogin, CONFIG.path.ssoLogout
];

export const API_URL = {
  LOGIN: "/auth/login",
  SSO_LOGIN: "/auth/sso/login",
  SSO_INFO: "/sso/info",
  AUTH_INFO_WITH_SSO: "/auth/sso/info",
  MFA_LOGIN: "/auth/mfa/login",
  LOGOUT: "/auth/logout",
  START_SESSION: "/session",
  JOIN_SESSION: "/session/joinSession",
  CREATE_USER_SESSION: "/session/createSession",
  VIEW_INVITEES: "/session/invitees",
  FORGOT_PASSWORD: "/user/forgotPassword",
  UPLOAD_CANVAS_THUMBNAIL: "/session/uploadThumbnail",
  UPLOAD_FILE: "/session/uploadFile",
  END_SESSION: "/session/end",
  CHECK_INVITE_USER: "/session/checkInvite",
  INVITE_USER: "/session/invite",
  INVITE_DETAILS_USER: "/session/inviteDetails",
  DOWNLOAD_CHAT: "/session/messages",
  SET_PASSWORD: "/user/setPassword",
  CUSTOMER: "/customer",
  CUSTOMER_SETTINGS: "/customer/settings",
  CUSTOMER_WITH_ADMIN: "/customer/withAdmin",
  USER: "/user",
  KMS_STATUS: "/session/kmsStatus",
  ALL_USERS_COUNT: "/user/count",
  ACTIVE_SESSION_COUNT: "/session/count",
  RESET_USER_PASSWORD: "/user/resetPassword",
  USER_UPLOAD_FILE: "/user/uploadFile",
  USER_UPLOAD_TENANT_WORDING_FILE: "/user/uploadWordingFile",
  USER_STATISTICS: "/user/statistics",
  USER_PROFILE: "/user/profile/@me",
  APP_EMULATION_DEVICE_INFO: "/appEmulation/deviceInfo/",
  APP_EMULATION_START_SESSION: "/appEmulation/startSession",
  APP_EMULATION_JOIN_SESSION: "/appEmulation/joinSession",
  APP_EMULATION_END_SESSION: "/appEmulation/endSession",
  UPDATE_URL: "/user/profile/updateUrl",
  GET_CUSTOMER: "/customer/getFromLicense",
  CREATE_USER_SESSION_WITH_LICENSE: "/session/createSessionWithLicense",
  CHANGE_PASSWORD: "/user/changePassword",
  SUB_LOGGING_LEVEL: "/customer/subLoggingLevel",
  GET_SESSSION_LIST: "/session/sessionsListing",
  GET_SESSION_WAIT_LIST: "/session/sessionsWaitListing",
  GET_SESSION_WAIT_LIST_TOKEN: "/session/sessionsWaitListingToken",
  GET_SESSION_DETAIL: "/session/report",
  GET_SESSION_DATA: "/session/data",
  CHECK_SESSION_DATA: "/session/checkSessionData",
  GET_PRESIGNED_OBJECT_URL: "/session/data/{objectId}/presigned",
  SAVE_SESSION_DATA: "/session/data",
  ANNOUNCEMENT: "/announcement",
  MSCLUSTER_STATISTICS: "/mscluster/statistics",
  TURNCLUSTER_STATISTICS: "turncluster/turnstatistics",
  MSCLUSTER_RETIREINSTANCE: "mscluster/retireInstance",
  SCHEDULE_SESSION: "/session/schedule",
  GET_SCHEDULE_SESSION_LIST: "/session/schedule",
  VERIFY_STORAGE: "/customer/storage/verify",
  CUSTOMER_STORAGE: "/customer/storage",
  CUSTOMER_RECORDING_STORAGE: "/customer/recordingStorage",
  GET_SESSION_KEY_FROM_PASSCODE: "/session/key/",
  GET_FILE_STRUCTURE_FROM_CLOUD: "/session/organizationTemplate/fileStructure",
  GET_FILE_URL_OF_REMOTE_FILE: "/session/organizationTemplate/getFileFromS3",
  CO_BROWSE_START_SESSION: "/cobrowse/startSession",
  CO_BROWSE_JOIN_SESSION: "/cobrowse/joinSession",
  CO_BROWSE_END_SESSION: "/cobrowse/endSession",
  CO_BROWSE_LEAVE_SESSION: "/cobrowse/leaveSession",
  BULK_IMPORT_USERS: "/user/bulkImport",
  CUSTOMER_CO_BROWSE: "/cobrowse/api2/call",
  CUSTOMER_CO_BROWSE_TEST: "/cobrowse/api2/call_test",
  // TODO:if not used, remove this block of code once we able to get data from co browse server
  CUSTOMER_CO_BROWSE_SESSION: "/cobrowse/#/session",
  GET_CO_BROWSE_SITES: "/session/cobrowse/targetSites",
  GET_CUSTOMER_SMS_SEND_NUM: "/customer/getCustomerSmsSendNum",
  GET_CUSTOMER_SESSION_NUM: "/customer/getCustomerSessionNum",
  DOWNLOAD_CUSTOMER_SESSION_NUM_CSV: "/customer/downloadCustomerSessionNumCSV",
  GET_CUSTOMER_ENCODING_TIME: "/customer/getCustomerEncodingTime",
  RESET_MFA: "/user/resetMFA",
  GET_RECORDING_OBJECT_URL: "/recording/data/{recordingDataId}/presigned",
  GET_RECORDING_DATA: "/recording/data",
  GET_ALL_OPERATORS: "/user/operator",
  GET_SUPPORT_CENTER_SESSIONS: "/session/supportcenter",
  CREATE_USER_SESSION_SUPPORT_CENTER: "/session/createSessionSupportCenter",
  SUPPORT_CENTER_REPORT: "session/supportCenterReport",
};
export const HTTP_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};
export const APP_CONFIG = {
  baseUrl: window._env_.REACT_APP_LOOOKIT_SERVICES_BASE_URL,
};

export const CANVAS_TYPES = {
  REGULAR: "REGULAR",
  PDF: "PDF",
  LOCATION: "LOCATION",
  IMAGE: "IMAGE",
};

export const CANVAS_SOURCE = {
  REGULAR: "REGULAR",
  PDF: "PDF",
  LOCATION: "LOCATION",
  IMAGE: "IMAGE",
  SNAPSHOT: "SNAPSHOT",
};

export const USER_ROLES = {
  AGENT: "AGENT",
  USER: "USER",
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
};

export const LOG_TYPE = {
  ADVANCED: "ADVANCED",
  BASIC: "BASIC",
};

export const STORAGE_LOCATION = {
  CUSTOMER: "CUSTOMER",
  LOOOKIT_CUSTOM: "LOOOKIT",
  LOOOKIT_GLOBAL: "LOOOKIT_GLOBAL",
};

export const SESSION_STATUS = {
  CLOSING: "CLOSING",
  ACTIVE: "ACTIVE",
  CREATED: "CREATED",
  WAITING: "WAITING",
  UPDATED: "UPDATED",
  DELETED: "DELETED",
  CLOSED: "CLOSED",
  ABANDONED: "ABANDONED",
};

export const PARTICIPANT_STATUS = {
  WAITING: "WAITING",
  ACTIVE: "ACTIVE",
  LEFT: "LEFT",
};

export const USER_ADMISSION_STATUS = {
  PENDING: "PENDING",
  ADMITTED: "ADMITTED",
  REJECTED: "REJECTED",
};

export const strings = {
  UserAlreadyExists: "User already exists.",
  UnauthorizedUser: "Unauthorized user",
  Forbidden: "Access denied",
  BadRequest: "Bad request",
  ServiceUnavailable: "Service unavailable",
  InternalServerError: "Internal server error",
  ResourceNotFound: "Requested resource not found",
};
export const queryParams = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CREATED: "CREATED",
  CLOSED: "CLOSED",
};
export const loginRegex = {
  USERNAME_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PASSWORD_REGEX: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
  NUMBER_REGEX: /^\+?[0-9]\d{8,14}$/,
};
export const supportedLanguages = {
  en: "English",
  ja: "日本語",
};

export const MODAL_TYPE = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const DEFAULT_LANGUAGE =
  window._env_.REACT_APP_DEFAULT_LANGUAGE || LANGUAGE.EN.name;

export const OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO =
  window._env_.REACT_APP_OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO;

export const LANGUAGE = {
  EN: {
    name: "en",
    value: "English",
  },
  JA: {
    name: "ja",
    value: "Japanese",
  },
};

export const Modules = {
  AUDIO: "AUDIO",
  AUDIO_VIDEO: "AUDIO_VIDEO",
  SCREENSHARE: "SCREENSHARE",
  CHAT: "CHAT",
  LOCATION: "LOCATION",
  CANVAS: "CANVAS",
  SNAPSHOT: "SNAPSHOT",
  PDF: "PDF",
  APP_EMULATION: "APP_EMULATION",
  CO_BROWSE: "CO_BROWSE",
  RECORDING: "RECORDING",
  SUPPORT_CENTER: "SUPPORT_CENTER",
};

export const DeactiveModules = {
  SCREEN_MASK: "SCREEN_MASK",
  AUDIO_SETTING: "AUDIO_SETTING",
};

export const cobrowseTypes = {
  CUSTOMER_CO_BROWSE: "CUSTOMER_CO_BROWSE",
  CUSTOMER_CO_BROWSE_V2: "CUSTOMER_CO_BROWSE_V2"
};

export const supportedMIMETypesForImage = [
  "image/png",
  "image/jpeg",
  "image/pjpeg",
  "image/x-png",
  "image/gif",
  "image/heif",
  "image/heic",
  "image/heif-sequence",
  "image/heic-sequence",
];

export const supportedMIMETypesForExcel = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/xls, application/x-dos_ms_excel",
  "application/x-ms-excel",
  "application/x-excel",
  "application/msexcel"
];

export const maxImageFileSize = 10000000;
export const maxPdfFileSize = 10000000;
export const maxBulkImportFileSize = 10000000;
export const pdfTronLibPath = "/lib/PDFTron/lib";

export const modulesAvailable = {
  AUDIO: "hasAudioModulePermission",
  VIDEO: "hasVideoModulePermission",
  SCREENSHARE: "hasScreenShareModulePermission",
  LOCATION: "hasLocationSharingModulePermission",
  CANVAS: "hasCanvasModulePermission",
  PDF: "hasPdfEditorModulePermission",
  MESSAGE: "hasMessageModulePermission",
};

export const modulesAvailableConstant = {
  CANVAS: "CANVAS",
  AUDIO: "AUDIO",
  AUDIO_VIDEO: "AUDIO_VIDEO",
  SCREENSHARE: "SCREENSHARE",
  LOCATION: "LOCATION",
  PDF: "PDF",
  CHAT: "CHAT",
  SNAPSHOT: "SNAPSHOT",
  APP_EMULATION: "APP_EMULATION",
  QR_CODE: "QR_CODE",
  ALLOW_DOWNLOAD: "ALLOW_DOWNLOAD",
  CO_BROWSE: "CO_BROWSE",
  SUPPORT_CENTER: "SUPPORT_CENTER",
  MFA: "MFA"
};
export const downloadableModules = {
  CANVAS: "CANVAS",
  CHAT: "CHAT",
  SCREENSHARE: "SCREENSHARE",
  PDF_BY_USER: "PDF_BY_USER",
  PDF_BY_AGENT: "PDF_BY_AGENT"
};
export const screenshareSubModules = {
  VIEW_SCREEN: "VIEW_SCREEN"
};
export const audiovideoSubModules = {
  SHOW_PREVIEW: "SHOW_PREVIEW"
};
export const listOfAvailableSubModule = ["CANVAS", "CHAT", "SCREENSHARE", "PDF_BY_USER", "VIEW_SCREEN", "PDF_BY_AGENT", "SHOW_PREVIEW"];

export const listOfAvailableModule = [
  "CANVAS",
  "AUDIO",
  "AUDIO_VIDEO",
  "SCREENSHARE",
  "CHAT",
  "LOCATION",
  "PDF",
  "SNAPSHOT",
  "APP_EMULATION",
  "QR_CODE",
  "ALLOW_DOWNLOAD",
  "CO_BROWSE"
];

export const notifySetting = {
  PASSWORD_CHANGED_COMPLETED: "PASSWORD_CHANGED_COMPLETED",
  QR_CODE: "QR_CODE"
};

export const largeIcon = {
  IS_ICON_LARGE: "IS_ICON_LARGE"
}

export const horizontalDisplayFixed = {
  IS_HORIZONTAL_DISPLAY_FIXED: "IS_HORIZONTAL_DISPLAY_FIXED"
}

export const modulesToDisplay = {
  CANVAS: "CANVAS",
  // PDF_EDITOR: "PDF_EDITOR",
  // ALLOW_DOWNLOAD: "ALLOW_DOWNLOAD",
  AUDIO: "AUDIO",
  AUDIO_VIDEO: "AUDIO_VIDEO",
  SCREENSHARE: "SCREENSHARE",
  SNAP_SHOT: "SNAP_SHOT",
  MSG: "MSG",
  LOCATION: "LOCATION",
  APP_EMULATION: "APP_EMULATION",
  QR_CODE: "QR_CODE",
  CO_BROWSE: "CO_BROWSE"
};

export const modulesForSessionContext = {
  CANVAS: "CANVAS",
  AUDIO: "AUDIO",
  AUDIO_VIDEO: "AUDIO_VIDEO",
  SCREENSHARE: "SCREENSHARE",
  PDF_EDITOR: "PDF_EDITOR",
  MSG: "MSG",
  LOCATION: "LOCATION",
  SNAP_SHOT: "SNAP_SHOT",
  APP_EMULATION: "APP_EMULATION",
  QR_CODE: "QR_CODE",
  CO_BROWSE: "CO_BROWSE"
};

export const TIMEOUT = {
  SHORT: 3000,
  LONG: 5000,
  API_REQUEST_TIMEOUT: 120000,
  AUDIO_VIDEO_FILM_STRIP_TIMEOUT: 5000,
};

export const ERROR = {
  INVALID_SESSION: "INVALID_SESSION",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  NETWORK_ERROR: "NETWORK_ERROR",
  NOT_AUTHORIZED: "NOT_AUTHORIZED",
  CUSTOMER_NOT_ACTIVE: "CUSTOMER_NOT_ACTIVE",
  INVALID_LICENSE_KEY: "INVALID_LICENSE_KEY",
  LICENSE_KEY_EXPIRED: "LICENSE_KEY_EXPIRED",
  INVALID_REQUEST_DATA: "INVALID_REQUEST_DATA",
  INVALID_DATA_REQUEST: "INVALID_DATA_REQUEST",
  SERVER_UNREACHABLE_ERROR: "SERVER_UNREACHABLE_ERROR",
  REQUEST_TIMEOUT_ERROR: "REQUEST_TIMEOUT_ERROR",
  FILE_SIZE_EXCEEDS_LIMIT: "FILE_SIZE_EXCEEDS_LIMIT",
  PASSCODE_ALREADY_BEING_USED: "PASSCODE_ALREADY_BEING_USED",
  CONNECTION_EXCEEDS_CAPACITY: "CONNECTION_EXCEEDS_CAPACITY",
  REQUEST_FAILED: "REQUEST_FAILED",
  TARGET_URL_NOT_FOUND: "TARGET_URL_NOT_FOUND",
  CO_BROWSE_ORIGIN_NOT_FOUND: "CO_BROWSE_ORIGIN_NOT_FOUND",
  SESSION_KEY_NOT_FOUND: "SESSION_KEY_NOT_FOUND",
  LAYOUT_CODE_NOT_FOUND: "LAYOUT_CODE_NOT_FOUND",
  CO_BROWSE_TOKEN_NOT_FOUND: "CO_BROWSE_TOKEN_NOT_FOUND",
  INVALID_CO_BROWSE_ORIGIN: "INVALID_CO_BROWSE_ORIGIN",
  INVALID_LAYOUT_CODE: "INVALID_LAYOUT_CODE",
  INVALID_CO_BROWSE_TOKEN: "INVALID_CO_BROWSE_TOKEN",
  WRONG_FILE_PASSWORD: "WRONG_FILE_PASSWORD",
  NOT_RECORDING_PASSWORD: "NOT_RECORDING_PASSWORD",
  USER_EVICTED_BY_AGENT: "USER_EVICTED_BY_AGENT",
  SUPPORT_CENTER_OUTSIDE_OF_BUSINESS_HOUR: "SUPPORT_CENTER_OUTSIDE_OF_BUSINESS_HOUR",
  SUPPORT_CENTER_ALL_OPERATOR_IS_ABSENCE: "SUPPORT_CENTER_ALL_OPERATOR_IS_ABSENCE",
};
export const COLOR = {
  BLACK: "black",
  RED: "red",
  GREEN: "green",
  BLUE: "blue",
  YELLOW: "yellow",
  ORANGE: "orange",
  PINK: "pink",
  PURPLE: "purple",
};

export const COLOR_LIST = [
  "black",
  "red",
  "green",
  "blue",
  "yellow",
  "orange",
  "pink",
  "purple",
];

export const CAMERA = {
  FRONT: "front",
  BACK: "back",
};

export const LANGUAGES = {
  en: "English",
  ja: "日本語",
  // chi: "中文"
};

export const supportedLanguagesName = {
  en: "English",
  ja: "Japanese",
  chi: "Chinese",
};

export const FONT_FAMILY = {
  ARIAL: "Arial",
  PACIFICO: "Pacifico",
  IMPACT_REGULAR: "Impact-Regular",
  MONACO: "Monaco",
  COURIER: "Courier",
};

export const DEFAULT_FONT_FAMILY = "Arial";

export const DEFAULT_FONT_SIZE = "40";

export const FONT_SIZE = [
  "24",
  "26",
  "28",
  "32",
  "36",
  "40",
  "44",
  "48",
  "54",
  "60",
];

export const PAGE_COUNT = [10, 20, 50, 100];
export const floatedAnnotationBar = {
  [ANNOTATIONS.TEXT]: {
    title: "TEXT_DECORATION",
    isSelected: false,
  },
  [ANNOTATIONS.CIRCLE]: {
    title: "CIRCLE",
    isSelected: false,
  },
  [ANNOTATIONS.RECTANGLE]: {
    title: "RECTANGLE",
    isSelected: false,
  },

  [ANNOTATIONS.LINE]: {
    title: "LINE",
    isSelected: false,
  },
  [ANNOTATIONS.FREE_HAND.NAME]: {
    title: "DRAW",
    isSelected: false,
  },
  [ANNOTATIONS.ERASER.NAME]: {
    title: "ERASER",
    isSelected: false,
  },
  [ANNOTATIONS.ERASE_OBJECT]: {
    title: "ERASE_OBJECT",
    isSelected: false,
  },
};

export const subLoggingLevels = {
  basic: {
    SESSION_DETAILS: "SESSION_DETAILS",
    INVITEE_LIST: "INVITEE_LIST",
    CONTEXT_EXCHANGE: "CONTEXT_EXCHANGE",
  },
  advanced: {
    CANVAS_OBJECTS: "CANVAS_OBJECTS",
    PDF: "PDF",
  },
};

export const loggingLevel = {
  BASIC: "BASIC",
  ADVANCED: "ADVANCED",
};

export const KMSInstanceInfo = {
  healthStatus: {
    HEALTHY: "HEALTHY",
    UNHEALTHY: "UNHEALTHY",
    RETIRING: "RETIRING",
  },

  instanceStatus: {
    RUNNING: "running",
    STOPPED: "stopped",
  },
};

export const defaultSubLoggingLevels = ["SESSION_DETAILS", "INVITEE_LIST"];

export const PARTICIPANT_LIMIT_SM = 3;
export const PARTICIPANT_LIMIT_LG = 5;

export const TESTS = {
  AUDIO: "Audio",
  CAMERA320: "Camera 320",
  CAMERA640: "Camera 640",
  CAMERA1280: "Camera 1280",
  CAMERA_SUPPORT: "Camera Supported Resolutions",
  RELAY: "Relay",
  HOST: "Host",
  REFLEXIVE: "Reflexive",
  ICE_SERVER_UDP: "Ice Server UDP",
  ICE_SERVER_TCP: "Ice Server TCP",
  UDP: "UDP",
  TCP: "TCP",
  IPv6: "IPv6",
  DATA_THROUGHPUT: "Data",
  VIDEO_BANDWIDTH: "Video Bandwidth",
};

export const COMPONENT_IN_FOCUS = {
  CANVAS: "CANVAS",
  AUDIO_VIDEO: "AUDIO_VIDEO",
  COBROWSE: "COBROWSE",
};

export const classNames = ['topLeft0', 'topRight0', 'topRight33', 'topRight35'];

export const REGEX = {
  CO_BROWSE_CUSTOM_URL: /^(http|https)?:\/\/?[a-zA-Z0-9@:%!$._\+~#-=&;]{1,256}\.[a-zA-Z0-9()]{1,50}\b([a-zA-Z0-9.=?\/]*)(:?\d+)?(\/\S*)?$/,
  URL: /^((https?|ftp|smtp):\/\/)?(www.)?[aA-zZ0-9]+\.[aA-zZ]+(\/[a-zA-Z0-9#]+\/?)*$/,
  TIME_PATTERN: {
    'H': '[0-2]',
    'h':'[0-9]',
    'M': '[0-5]',
    'm': '[0-9]',
  },
  TIME: /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/,
  DATE_TIME_PATTERN: {
    'M': '[0-1]',
    'o': '[0-9]',
    'D': '[0-3]',
    'e': '[0-9]',
    'y': '[0-9]',
    'h': '[0-1]',
    'H': '[0-9]',
    'm': '[0-6]',
    'i': '[0-9]',
    'a': '[AaPp]',
    't': '[mM]'
  }
};

export const SESSION_TYPE = {
  INSTANT_MEETING: "INSTANT_MEETING",
  SCHEDULE_MEETING: "SCHEDULE_MEETING",
  UPDATE_SCHEDULE_MEETING: "UPDATE_SCHEDULE_MEETING",
};

export const SCHEDULED_SESSION_MESSAGE = {
  CREATED: "USER_SESSION_WAITING_MESSAGE",
  WAITING: "USER_SESSION_WAITING_MESSAGE",
  UPDATED: "USER_SESSION_UPDATED_MESSAGE",
  DELETED: "USER_SESSION_DELETED_MESSAGE",
};

export const USER_ADMISSION_MESSAGE = {
  REJECTED: "USER_REJECTED_MESSAGE",
  PENDING: "USER_SESSION_WAITING_MESSAGE",
};

export const SESSION_SUBTYPES = {
  REGULAR: "REGULAR",
  SCHEDULED: "SCHEDULED",
};

export const TIME_INTERVAL = {
  SESSION_TABLE_REFRESH_TIME_INTERVAL: 1000,
  MAXINTERVALS: 10,
  PASSCODE_CHECK_TIME_INTERVAL: 200
};

export const MEETING_JOIN_TYPE = {
  JOIN_WITH_MEETING_CODE: "JOIN_WITH_MEETING_CODE",
  SET_UP_NEW_MEETING: "SET_UP_NEW_MEETING"
};

export const PASSCODE_LENGTH = 4;

export const BANDWIDTH_MANAGEMENT_LIST = [{
  name: "LOW_BANDWIDTH",
  value: 360,
  bitrate: "400 kbps"
}, {
  name: "MEDIUM_BANDWIDTH",
  value: 720,
  bitrate: "1.5 mbps"
}, {
  name: "HIGH_BANDWIDTH",
  value: 1080,
  bitrate: 0
}];
export const BANDWIDTH_IDX_LOW = 0;
export const BANDWIDTH_IDX_MEDIUM = 1;

export const FRAMES_PER_SECOND_LIST = [5, 10, 15, 20, 25, 30];
export const DEFAULT_FPS = 15;

export const CO_BROWSE_SESSION_STATUS = {
  CO_BROWSE_STARTED: "CO_BROWSE_STARTED",
  CO_BROWSE_RUNNING: "CO_BROWSE_RUNNING",
  CO_BROWSE_NOT_RUNNING: "CO_BROWSE_NOT_RUNNING",
  CO_BROWSE_STOPPED: "CO_BROWSE_STOPPED"
};

export const BUSINESS_MODELS = {
  NUMBER_OF_SEATS: "NUMBER_OF_SEATS",
  MAX_CONCURRENT_CONNECTIONS: "MAX_CONCURRENT_CONNECTION",
};

export const RECORD_NOT_PROCESSED = "RECORD_NOT_PROCESSED";

export const CO_BROWSE_LAYOUT = {
  laptop: "1",
  tablet: "2",
  mobileVertical: "3",
  mobileHorizontal: "4",
};

export const CUSTOMER_CO_BROWSE_RESPONSE = {
  START_SUCCESS: "start-success",
  START_FAIL: "start-failed",
  END_SUCCESS: "end-success",
  END_CANCEL: "end-cancel",
  END_FAIL: "end-fail"
};
export const CUSTOMER_CO_BROWSE_ACTIONS = {
  END_SESSION: "End_session",
  CO_BROWSER_START: "cobrowserStart",
  CO_BROWSER_END: "cobrowserEnd",
  END_SESSION_WITHOUT_CONFIRMATION: "End_session_without_confirmation",
  CO_BROWSER_RECONNECT: "cobrowserReconnect",
};
export const CUSTOMER_CO_BROWSE_ERROR = {
  1001: ERROR.REQUEST_FAILED,
  1200: ERROR.INVALID_DATA_REQUEST,
  1010: ERROR.TOKEN_VALIDATION_FAILED,
  1201: ERROR.INVALID_PARAMETER_FORMAT,
  1101: ERROR.TARGET_URL_NOT_FOUND,
  10100: ERROR.CO_BROWSE_ORIGIN_NOT_FOUND,
  10101: ERROR.SESSION_KEY_NOT_FOUND,
  10102: ERROR.LAYOUT_CODE_NOT_FOUND,
  11100: ERROR.CO_BROWSE_TOKEN_NOT_FOUND,
  11101: ERROR.INVALID_CO_BROWSE_ORIGIN,
  10200: ERROR.INVALID_LAYOUT_CODE,
  10201: ERROR.INVALID_CO_BROWSE_TOKEN
};

export const LOCATOR = {
  SSO: "sso",
  STORAGE: "storage",
  RECORDING_STORAGE: "recordingStorage",
  CO_BROWSE: "cobrowse",
  SUPPORT_CENTER: "supportCenter",
};

export const MFA_CONST = {
  QRCODE_TIMEOUT: 900000
};

export const RECORDING_METHOD = {
  OFF: "RECORDING_OFF",
  AUTO: "RECORDING_AUTO",
  MANUAL: "RECORDING_MANUAL"
};

export const RECORDING_TARGET = {
  AUDIO: "AUDIO_RECORDING",
  VIDEO: "VIDEO_RECORDING",
  // FULL_SCREEN_SHARING: "FULL_SCREEN_SHARING"
};

export const RECORDING_PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,15}$/;

export const STORAGE = {
  STORAGE: "storage",
  RECORDING_STORAGE: "recordingStorage"
};

export const CONTRACT_DISPLAY_METHOD = {
  AUTO: "AUTO",
  MANUAL: "MANUAL"
};

export const TOAST_ID = {
  ADMIT: "UserArrivedToastId",
};

export const NAME_NG_REGEX = /[!"#$%&'()\*\+\.,\/:;<=>?@\[\\\]^`{|}~]/;

export const CALLING_PREVIEW = {
  PREVIEW_AUDIO: "previewAudio",
  PREVIEW_VIDEO: "previewVideo",
  PREVIEW_REVERSE: "previewReverse",
  PREVIEW_VIRTUAL_BACKGROUND: "previewVirtualBackground",
};

export const maxPassLength = 128;
export const minPassLength = 6;
export const passwordPolicyNum = 2;
export const passwordPolicy = {
  UPPERCASE: "UPPERCASE",
  LOWERCASE: "LOWERCASE",
  WITHNUMBER: "WITHNUMBER",
  SPECIALCHAR: "SPECIALCHAR"
};
export const maxPassHist = 10;
export const minPassHist = 1;

export const passwordPolicyName = ["useUpper", "useLower", "useNumber", "useSpecialChar"];

export const SCREEN_MASK_MODE = {
  PRESENTER: 0,
  AGENT: 1,
  NOT_USE: 2,
};

export const SMS_MESSAGE_MAX_LENGTH = {
  EN: 1000,
  JA: 500,
};

export const FULL_SCREEN_V2_ID = {
  SUFFIX: "FSV2",
};

export const MAX_Z_INDEX = {
  AUDIO_VIDEO: 2,
  SCREEN_SHARE: 10,
};

import bg1 from "ASSETS/Images/virtualbg/bg1.webp";
import bg2 from "ASSETS/Images/virtualbg/bg2.webp";
import bg3 from "ASSETS/Images/virtualbg/bg3.webp";
export const FILTER_NAME = {
  BLUR: "BLUR",
  BG1: "BG1",
  BG2: "BG2",
  BG3: "BG3",
};
export const FILTER_CONFIG = {
  BLUR: {blur: true},
  BG1: {blur: false, image: bg1},
  BG2: {blur: false, image: bg2},
  BG3: {blur: false, image: bg3},
};
export const VIRTUAL_BACKGROUND = {
  RESOLUTION_ADJUSTMENT_VALUE: 2,
  VIDEO_HEIGHT_BASE: BANDWIDTH_MANAGEMENT_LIST[BANDWIDTH_IDX_LOW].value,
  BLUR_RADIUS_PIXEL_BASE: 5,
  BLUR_RADIUS_PIXEL_BASE_FOR_SAFARI: 12,
}

export const OPERATOR_STATUS_LIST = [
  "CORRESPONDENCE",
  "CALLING",
  "WAITING",
  "LEAVING",
  "ABSENCE",
];

export const OPERATOR_STATUS = {
  CORRESPONDENCE: "CORRESPONDENCE",
  CALLING: "CALLING",
  WAITING: "WAITING",
  LEAVING: "LEAVING",
  ABSENCE: "ABSENCE",
};

export const DAY_OF_WEEK = {
  MON: "MONDAY",
  TUE: "TUESDAY",
  WED: "WEDNESDAY",
  THU: "THURSDAY",
  FRI: "FRIDAY",
  SAT: "SATURDAY",
  SUN: "SUNDAY",
};